import { create } from 'zustand';
import { type Role } from '@/models';
import { type Organization } from '@/models/organization';
import { createPersistentStore } from '@/stores/shared/createPersistentStore';
import { createDataStore } from '../shared/createDataStore';

interface RoleStore {
  roles: string[];
  load: boolean;
  youRole: Role;
  setYouRole: (role: Role) => void;
  setData: (roles: string[]) => void;
}
export const useOrganizationRoleStore = create<RoleStore>((set) => ({
  roles: ['admin', 'member', 'owner'],
  load: false,
  youRole: 'member',
  setYouRole: (role: Role) => {
    set({ youRole: role });
  },
  setData: (roles) => {
    set({ roles: roles });
  },
}));

interface TeamStoreSchema {
  team: string;
  // you: Partial<ZTypeOrganizationTeams>
}

export const useOrganizationsTeamStore =
  createPersistentStore<TeamStoreSchema>('organizations_team');
export const useOrganizationStore = createDataStore<Organization & { project_id: string }>();
export const useMeOrganizationStore = createDataStore<Organization[]>();
